import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'

const CardGallery = props => {
  const cards = props.cards.map(card => (
    <div className='gallery-item' key={card}>
      {cloneElement(props.children, { id: card })}
    </div>
  ))
  return <div className='gallery-container'>{cards}</div>
}

CardGallery.propTypes = {
  cards: PropTypes.array.isRequired
}

export default CardGallery



// WEBPACK FOOTER //
// ./src/ui/cards/card-gallery.js